import script from "./ResetPassword.vue?vue&type=script&setup=true&lang=ts"
export * from "./ResetPassword.vue?vue&type=script&setup=true&lang=ts"

import "./ResetPassword.vue?vue&type=style&index=0&id=5112fc91&scoped=true&lang=scss"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.40_vue@3.5.40_typescript@5.9.3__webpack@5.108.4_postcss@8.5.22_/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5112fc91"]])

export default __exports__